import React, { useState, ChangeEvent, FormEvent } from 'react';
import api from '../../../utils/api';
import styled from 'styled-components';
import Word from '../../../models/Word';
import { ActionButton,CancelButton } from '../common/AdminButtons';
import { Form, Input, FormGroup, ButtonGroup } from '../common/AdminForm';
import { ErrorMessage } from '../common/AdminMessages';
import { FormContainer } from '../common/FormContainer';


// Props interface for the WordForm component
interface WordUplaodFormProps {
    jargonId: number; // Required for associating words with a Jargon
    onSuccess: (wordsAdded:number) => void;
    onCancel: () => void;
}

const WordUploadForm: React.FC<WordUplaodFormProps> = ({ jargonId, onSuccess, onCancel }) => {
    
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [file, setFile] = useState<File|null>(null);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
        }
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        if (!file) {
            setErrorMessage('Please select a file before uploading.');
            return;
        }
        const formData = new FormData();
        formData.append('file', file);

        let response;
        try {
                //post the file to '/halo/words/jargon/id'
                response = await api.post<number>(`/halo/words/jargon/${jargonId}`,formData, {headers:{'Content-Type':'multipart/form-data',},}); 

            if (response.status >= 200 && response.status < 300) {
                onSuccess(response.data); //I am assuming data will be a number here
            } else {
                setErrorMessage(`HTTP ${response.status}: ${response.statusText}`);
                console.log(`Received HTTP ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            setErrorMessage('Failed to save the words.');
            console.error("Error saving words:", error);
        }
    };
    return (
        
        <FormContainer>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Form onSubmit={handleSubmit}>
                <label htmlFor="file">Select File
                    <Input type="file" name="file" onChange={handleFileChange} />
                </label>
                
                <ButtonGroup>
                    <ActionButton type="submit">
                        Upload Words
                    </ActionButton>
                    <CancelButton type="button" onClick={onCancel}>
                        Cancel
                    </CancelButton>
                </ButtonGroup>
            </Form>
        </FormContainer>
    );
};

export default WordUploadForm;
